import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';
import type { EntryPointActions } from '@atlassian/jira-entry-point/src/controllers/utils/types.tsx';
import { CellHoverProvider } from '@atlassian/jira-hover-popover/src/controllers/index.tsx';
import ShowMorePopup, { type Props as PopupProps } from './show-more-popup/index.tsx';

export type Props = {
	/**
	 * The component with the first item to be rendered before the popup
	 */
	ItemComponent: React.JSX.Element | undefined;
	entryPointActions?: EntryPointActions;
} & PopupProps;

const ItemWithPopup = ({
	ItemComponent,
	showMoreTooltip,
	totalItems,
	PopupComponent,
	isOpen,
	onSetIsOpen,
	triggerRefCallback,
	actionSubjectIdPrefix,
	isTruncated = false,
	entryPointActions,
}: Props) => {
	if (ItemComponent === undefined) {
		return null;
	}

	const shouldTruncated = isTruncated && fg('jsc_inline_editing_field_refactor');

	return (
		<Inline space="space.100" alignBlock="center" shouldWrap={!shouldTruncated}>
			{ItemComponent}
			{totalItems > 1 && (
				<CellHoverProvider>
					<ShowMorePopup
						showMoreTooltip={showMoreTooltip}
						totalItems={totalItems - 1}
						PopupComponent={PopupComponent}
						isOpen={isOpen}
						onSetIsOpen={onSetIsOpen}
						triggerRefCallback={triggerRefCallback}
						actionSubjectIdPrefix={actionSubjectIdPrefix}
						isTruncated={isTruncated}
						entryPointActions={entryPointActions}
					/>
				</CellHoverProvider>
			)}
		</Inline>
	);
};

export default ItemWithPopup;
